import {
  Backdrop,
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  IconButton,
  Modal,
  Paper as MuiPaper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { customOrange } from "core/theme/variants";
import { FunctionComponent, useState } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80vw", sm: "50vw" },
  bgcolor: customOrange[700],
  borderRadius: "15px",
  p: 5,
};

const Paper = styled(MuiPaper)(spacing);

const Content = styled(Paper)`
  flex: 1;
  background: #fff;
  padding: 20px;
  border-radius: 15px;
  position: relative;
`;

interface Props {}

const Avatar: FunctionComponent<Props> = ({ ...otherProps }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [siteToShow, setSiteToShow] = useState("");
  const { t } = useTranslation();

  return (
    <>
      <Box
        component={"footer"}
        sx={{
          backgroundColor: theme.palette.primary.main,
          p: 4,
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item>
            <Button
              variant="text"
              sx={{
                color: "#fff",
              }}
              onClick={() => {
                setIsModalOpen(true);
                setSiteToShow(
                  "https://www.iubenda.com/privacy-policy/14774579"
                );
              }}
            >
              {t("policies.privacy")}
            </Button>
          </Grid>
          {!isSmall && (
            <Grid item>
              <Divider orientation="vertical" sx={{ background: "#fff" }} />
            </Grid>
          )}
          <Grid item>
            <Button
              variant="text"
              sx={{
                color: "#fff",
              }}
              onClick={() => {
                setIsModalOpen(true);
                setSiteToShow(
                  "https://www.iubenda.com/privacy-policy/14774579/cookie-policy"
                );
              }}
            >
              {t("policies.cookie")}
            </Button>
          </Grid>
          {!isSmall && (
            <Grid item>
              <Divider orientation="vertical" sx={{ background: "#fff" }} />
            </Grid>
          )}
          <Grid item>
            <Button
              variant="text"
              sx={{
                color: "#fff",
              }}
              onClick={() =>
                window.open(
                  "https://www.miareputation.com/tos",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              {t("policies.therms")}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={isModalOpen}>
          <Box sx={style}>
            <Content>
              <IconButton
                onClick={() => {
                  setIsModalOpen(false);
                }}
                sx={{
                  position: "absolute",
                  right: 5,
                  top: 5,
                }}
              >
                <CloseRoundedIcon color="info" />
              </IconButton>
              <Box mt={"10px"}>
                <iframe
                  src={siteToShow}
                  style={{ width: "100%", height: "400px", border: 0 }}
                  title="Contenuto Modal"
                ></iframe>
              </Box>
            </Content>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Avatar;
